import { da } from "date-fns/locale";
import App from "../App";
import { ThemeContentFactory } from "../factory/themeContentFactoryComp"
import { ThemeSideNav } from "../molecule/themeSidenav"
import { HorizontalLayout } from "./layout"
import { ThemePreviewComp } from "./themePreviewComp"
import { useEffect, useState } from "react";
import { getAPI } from "../api/api";
import { set } from "date-fns";

export const ThemeSettings = () => {
    const [activeSetting, setActiveSetting] = useState(1);
    const [themeData, setThemeData] = useState({})

    const items = [
        { "navID": "1", "title": "Tekst" },
        { "navID": "2", "title": "Kleuren" },
        { "navID": "3", "title": "Vormen" },
        { "navID": "4", "title": "Branding" },
        { "navID": "5", "title": "Titels" }
    ];

    const handleNavClick = (navID) => {
        setActiveSetting(parseInt(navID));
    };
    const [data, setData] = useState({
            "primary": "#486688",
            "secondary": "#486688",
            "sidebar": "#fffffF",
            "background": "#f8f9fa", 
            "borders":"#f1f1f1", 
            "cards":"#FFFFFF", 
            "topbar":"#FFFFFF", 
            "borders2":"#f1f1f1",  
            "text":"#18222d",
            "card_text": "#333333",
            "sub_text": "#333333",
            "sidebar_style":1})

    useEffect(() => {
        loadThemeData()
    }, []);

    const loadThemeData = async () => { 
            const query = "api/business/theme"
            const themeData = await getAPI(query)
            if(themeData.data.length){
                setData(themeData.data[0])
            }
    }
    return(
        <HorizontalLayout className="phone-theme-creator settings-card" style={{padding:"1rem", width:"unset"}}>
            <ThemeSideNav
                navItems={items}
                handleNavClick={handleNavClick}
            />
            
            <ThemeContentFactory
                data={data}
                setData={(data) => setData((prevState) => ({...prevState, ...data}))}
                setting={activeSetting}
            />
            <ThemePreviewComp
                data={data}
            />
                
        </HorizontalLayout>
    )
}


